import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditAuthorityComponent } from '@app/core/windows'; 


@Component({
  selector: 'authorities-crud',
  templateUrl: './authorities-crud.component.html',
  providers: [ DatasourceService ]
})
export class AuthoritiesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditAuthorityComponent, {static: false}) window !: CreateEditAuthorityComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Autoridad';

  protected name: string = 'Autoridades';

  protected table: string = 'authorities';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}